interface GameFormValues {
  gameName: string;
  access: string;
  accesscode: string;
  type: string;
  stakes: string;
  game: string;
  date: string;
  state: string;
  city: string;
  zipcode: string;
  address: string;
  buyin: string;
  custombuyin: string;
  fee: string;
  customfee: string;
  minPlayers: string;
  maxPlayers: string;
  [key: string]: string;
}

export function validateInput(values: GameFormValues) {
  const minPlayers = parseInt(values.minPlayers);
  const maxPlayers = parseInt(values.maxPlayers);
  const errs: Record<string, string> = {};

  if (values.gameName === "") {
    errs.gameName = "Please name your game";
  }
  if (values.access === "Private") {
    const cLen = values.accesscode.length;
    if (cLen < 4 || cLen > 12) {
      errs.accesscode = "Access code must be between 4 and 12 characters";
    }
  }
  if (values.type === "Cash" && values.stakes === "") {
    errs.stakes = "Please select stakes";
  }
  if (values.game === "") {
    errs.game = "Please select game";
  }
  if (values.date === "") {
    errs.date = "Please select a day";
  }
  if (values.state === "") {
    errs.state = "Please select a state";
  }
  if (values.city === "") {
    errs.city = "Please select a city";
  }
  if (values.address === "" || values.address.trim() === "") {
    errs.address = "Please enter an address";
  }
  if (values.zipcode.length !== 5) {
    errs.zipcode = "Please enter a zip code";
  }
  if (values.type === "Tournament") {
    if (
      values.buyin === "" ||
      (values.buyin === "Custom" && values.custombuyin === "")
    ) {
      errs.custombuyin = "Please set a buy in value";
    }
    if (
      values.fee === "" ||
      (values.fee === "Custom" && values.customfee === "")
    ) {
      errs.customfee = "Please set a fee";
    }
  }
  if (minPlayers < 2) {
    errs.minPlayers = "At least 2 people are required to start a game";
  }
  if (minPlayers > maxPlayers) {
    errs.maxPlayers =
      "The minimum number of people cannot be more than the max number of people";
  }
  return errs;
}
